import { AxiosRequestConfig, AxiosResponse } from 'axios';
import {
  getAssembleiasAssessorEndpoint,
  getAssembleiasAssessorMessengerEndpoint,
} from 'library/Apis';
import api from 'services/ApiService';
import {
  getAssembleiasAssessorBffEndpoint,
  getAssembleiasAssessorRelatoriosEndpoint,
} from '../../library/Apis';

export interface ErrorAPI {
  code: string;
  details: ErrorAPI[];
  error: string;
  message: string;
}

export interface Pagination<T> {
  elements: T;
  totalElements: number;
  totalPages: number;
}

interface ResponseAPI<T> {
  fail?: ErrorAPI;
  data?: T;
  response?: AxiosResponse<T>;
}

export interface Success {
  body: any;
  statusCode: string;
  statusCodeValue: number;
}

const generic = { message: 'Ocorreu algo inesperado' };

export async function get<T>(
  endpoint: string,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorEndpoint()}${endpoint}`;
  try {
    const response = await api.get<T>(url, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    const err = error as any;
    return {
      response: err!?.response!,
      fail: err!?.response?.data || generic,
    };
  }
}

export async function messengerGet<T>(
  endpoint: string,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorBffEndpoint()}${endpoint}`;
  try {
    const response = await api.get<T>(url, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    const err = error as any;
    return {
      response: err!?.response!,
      fail: err!?.response?.data || generic,
    };
  }
}

export async function post<T>(
  endpoint: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorEndpoint()}${endpoint}`;
  return callPost(url, data, config);
}

export async function postBff<T>(
  endpoint: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorBffEndpoint()}${endpoint}`;
  return callPost(url, data, config);
}

export async function callPost<T>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  try {
    const response = await api.post<T>(url, data, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    const err = error as any;
    return {
      response: err!?.response!,
      fail: err!?.response?.data || generic,
    };
  }
}

export async function relatoryPost<T>(
  endpoint: string,
  data?: any,
  config?: AxiosRequestConfig,
  fullError?: boolean
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorRelatoriosEndpoint()}${endpoint}`;
  try {
    const response = await api.post<T>(url, data, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    const err = error as any;

    const decode = new TextDecoder().decode(err.response.data);
    const errObj = JSON.parse(decode);

    if (fullError) {
      return {
        response: err!?.response!,
        fail:
          err.response.data instanceof ArrayBuffer ? errObj : err || generic,
      };
    } else {
      return {
        response: err!?.response!,
        fail:
          err.response.data instanceof ArrayBuffer ? errObj : err || generic,
      };
    }
  }
}

export async function relatoryGet<T>(
  endpoint: string,
  config?: AxiosRequestConfig,
  fullError?: boolean
): Promise<ResponseAPI<T>> {
  try {
    const response = await api.get<T>(endpoint, config);

    return {
      data: response.data,
      response,
    };
  } catch (error) {
    const err = error as any;

    const decode = new TextDecoder().decode(err.response.data);
    const errObj = JSON.parse(decode);

    if (fullError) {
      return {
        response: err!?.response!,
        fail:
          err.response.data instanceof ArrayBuffer ? errObj : err || generic,
      };
    } else {
      return {
        response: err!?.response!,
        fail:
          err.response.data instanceof ArrayBuffer ? errObj : err || generic,
      };
    }
  }
}

export async function messengerPost<T>(
  endpoint: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorMessengerEndpoint()}${endpoint}`;
  return new Promise((resolve, reject) => {
    api
      .post<T>(url, data, config)
      .then((response) => {
        resolve({
          data: response.data,
          response,
        });
      })
      .catch((error: any) => {
        reject({
          response: error!?.response!,
          fail: error?.response?.data || generic,
        });
      });
  });
}

export async function put<T>(
  endpoint: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorEndpoint()}${endpoint}`;
  return callPut(url, data, config);
}

export async function putBff<T>(
  endpoint: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorBffEndpoint()}${endpoint}`;
  return callPut(url, data, config);
}

export async function callPut<T>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  try {
    const response = await api.put<T>(url, data, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    const err = error as any;
    return {
      response: err!?.response!,
      fail: err!?.response?.data || generic,
    };
  }
}

export function messengerPut<T>(
  endpoint: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorMessengerEndpoint()}${endpoint}`;
  return new Promise((resolve, reject) => {
    api
      .put<T>(url, data, config)
      .then((response: any) => {
        resolve({
          data: response.data,
          response,
        });
      })
      .catch((err: any) => {
        reject({
          response: err!?.response!,
          fail: err!?.response?.data || generic,
        });
      });
  });
}

export async function del<T>(
  endpoint: string,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorEndpoint()}${endpoint}`;
  return callDelete(url, config);
}

export async function delBff<T>(
  endpoint: string,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorBffEndpoint()}${endpoint}`;
  return callDelete(url, config);
}

export async function callDelete<T>(
  url: string,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  try {
    const response = await api.delete<T>(url, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    const err = error as any;
    return {
      response: err!?.response!,
      fail: err!?.response?.data || generic,
    };
  }
}

export async function messengerDel<T>(
  endpoint: string,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorMessengerEndpoint()}${endpoint}`;
  return new Promise((resolve, reject) => {
    api
      .delete<T>(url, config)
      .then((response: any) => {
        resolve({
          data: response.data,
          response,
        });
      })
      .catch((error: any) => {
        reject({
          response: error!?.response!,
          fail: error!?.response?.data || generic,
        });
      });
  });
}
